import { render, staticRenderFns } from "./CustomerServiceTyping.vue?vue&type=template&id=5800af2a&scoped=true&"
import script from "./CustomerServiceTyping.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceTyping.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceTyping.vue?vue&type=style&index=0&id=5800af2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5800af2a",
  null
  
)

export default component.exports